export default "__VITE_ASSET__6acfc08a__"